import { Form, Slider } from 'antd';
import React from 'react';

import { ItemType } from '../../types';

interface IFieldCompletionPercentage {
    disabled?: boolean;
}

const FieldCompletionPercentage: React.FC<IFieldCompletionPercentage> = ({ disabled }) => {
    return (
        <Form.Item<ItemType> label="Completion percentage" name="completionPercentage">
            <Slider disabled={disabled} step={1} style={{ width: '100%' }} />
        </Form.Item>
    );
};

export default React.memo(FieldCompletionPercentage);
